import React, { Fragment, useEffect, useState } from "react";
// store
import { PAGINATION_LIMIT, API } from "../../../../store/config";
import moment from "moment";
import "moment/locale/sk";
// components
import { Table, Pagination, Icon } from "semantic-ui-react";

// component
function StornoRecordsTable({ records }) {
    const [tableData, setTableData] = useState(
        records.slice(0, PAGINATION_LIMIT)
    );

    // set data to table
    useEffect(() => {
        setTableData(records.slice(0, PAGINATION_LIMIT));
    }, [records]);

    const handleChangePage = (event, data) => {
        setTableData(
            records.slice(
                data.activePage * PAGINATION_LIMIT - PAGINATION_LIMIT,
                data.activePage * PAGINATION_LIMIT
            )
        );
    };

    // template
    return (
        <Fragment>
            <Table striped unstackable style={{ overflow: "auto" }}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell textAlign="left">Dátum refundácie</Table.HeaderCell>
                        <Table.HeaderCell>Aktivita / Termín</Table.HeaderCell>
                        <Table.HeaderCell>Zadávateľ</Table.HeaderCell>
                        <Table.HeaderCell>Vrátna suma (70%)</Table.HeaderCell>
                        <Table.HeaderCell>Storno poplatok (30%)</Table.HeaderCell>
                        <Table.HeaderCell>Pôvodna cena termínu</Table.HeaderCell>
                        <Table.HeaderCell textAlign="left">Faktúra a zápočet</Table.HeaderCell>
                        <Table.HeaderCell textAlign="left">Dobropis</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {tableData.length === 0 &&
                        <Table.Row>
                            <Table.Cell colSpan={10} style={{ textAlign: "center", fontWeight: "bold" }}>
                                Vo zvolenom období neboli najdené žiadne záznamy
                            </Table.Cell>
                        </Table.Row>
                    }
                    {tableData.map((record) => (
                        <Table.Row key={record.id}>
                            <Table.Cell textAlign="left">
                                {record.storno_when ? moment(record.storno_when).format("DD.MM.YYYY") : "-"}
                            </Table.Cell>
                            <Table.Cell>
                                {record.product?.event?.name} - {moment(record.product?.event?.starts).format("DD.MM.YYYY HH:mm")} <br />
                                <span style={{ fontSize: "0.9rem" }}>Miesto konania: <strong>{record.product?.event?.address}</strong> </span>
                            </Table.Cell>
                            <Table.Cell>
                                {record.product?.provider?.nickname} <br />
                                <span style={{ opacity: 0.8 }}> <a style={{ color: "var(--primary)" }} href={`mailto:${record.product?.provider?.user?.email}`} > {record.product?.provider?.user?.email}</a> </span>
                            </Table.Cell>
                            <Table.Cell>
                                <span> {record.storno_amount} EUR</span>
                            </Table.Cell>
                            <Table.Cell>
                                <span> {record.storno_remaining_amount} EUR</span>
                            </Table.Cell>
                            <Table.Cell>
                                <span> {record.product.price} EUR</span> <br />
                                <span style={{ fontSize: "0.9rem" }}>Zakúpené: <strong>{moment(record.product?.created).format("DD.MM.YYYY")}</strong></span>
                            </Table.Cell>
                            <Table.Cell textAlign="left">
                                <a href={API.STORNO + "records/" + record.id + '/docs/'} target="_blank" rel="noopener noreferrer">
                                    <Icon name="file pdf" style={{ color: "red", fontSize: "1.2rem" }} />
                                    <span style={{ fontWeight: "bold", color: "black" }}>Zobraziť</span>
                                </a>
                            </Table.Cell>
                            <Table.Cell textAlign="left">
                                <a href={API.STORNO + record.id + '/docs/'} target="_blank" rel="noopener noreferrer">
                                    <Icon name="file pdf" style={{ color: "red", fontSize: "1.2rem" }} />
                                    <span style={{ fontWeight: "bold", color: "black" }}>Zobraziť</span>
                                </a>
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
            <Pagination
                defaultActivePage={1}
                totalPages={Math.ceil(
                    records.length / PAGINATION_LIMIT
                )}
                onPageChange={handleChangePage}
                boundaryRange={0}
                siblingRange={0}
            />
        </Fragment>
    );
}

export default StornoRecordsTable;
